module.exports = __webpack_public_path__ + "img/plus.b7bb2fe.svg";